
export { ShoppingBagButton } from "/codebuild/output/src4265788598/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"